import type { Adventure } from '../../types'

// Skip Counting Safari - Age 5 - Skip counting by 2s
export const tillySkipCorrect = [
  "Perfect! You're counting by 2s!",
  "That's right! Skip counting master!",
  "Excellent! 2, 4, 6, 8... you got it!",
  "Wonderful! You're skip counting!",
  "Yes! Counting by twos!",
  "Brilliant! You see the pattern!",
  "Super job! Keep counting by 2s!",
  "You got it! Every other number!",
  "Fantastic skip counting!",
  "Amazing! You're a counting expert!"
]

export const tillySkipWrong = [
  "Count by 2s: 2, 4, 6, 8... what's next?",
  "Almost! Skip every other number!",
  "Good try! Count: 2, 4, 6, ?",
  "So close! Remember to add 2 each time!",
  "Think about adding 2 to the last number!",
  "You're learning! Count: 2, 4, 6, 8, ?",
  "Try again! Skip one number each time!",
  "Add 2 to get the next number!",
  "Let's count by 2s together!",
  "Keep trying! Skip counting is fun!"
]

export const skipCountingAdventure: Adventure = {
  id: 'skip-counting',
  title: 'Skip Counting Safari',
  theme: 'numbers',
  targetAge: '5',
  difficulty: 'medium',
  estimatedDuration: 10,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello counting champion! I am Tilly! Today we are learning to skip count by 2s - it is like taking bigger steps!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Instead of counting 1, 2, 3, 4... we skip! 2, 4, 6, 8! We are counting every second number!",
      duration: 5
    },
    choice1: [
      {
        id: 'pairs',
        label: 'Count pairs!',
        tillyLine: "Things come in pairs!",
        nextState: 'quiz-1'
      },
      {
        id: 'jump',
        label: 'Jump counting!',
        tillyLine: "Jump by 2s!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'pattern-complete',
      question: 'What is next? 2, 4, 6, ?',
      tillyPrompt: 'Add 2 to 6!',
      options: [
        { id: 'seven', label: '7', isCorrect: false },
        { id: 'eight', label: '8', isCorrect: true },
        { id: 'nine', label: '9', isCorrect: false }
      ],
      pattern: [2, 4, 6],
      correctAnswer: 8
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great! Skip counting helps us count faster! Let us try with animal legs - they come in pairs of 2!",
      duration: 4
    },
    choice2: [
      {
        id: 'animals',
        label: 'Animal legs!',
        tillyLine: "Animals have 4 legs!",
        nextState: 'quiz-2'
      },
      {
        id: 'shoes',
        label: 'Shoes pairs!',
        tillyLine: "Shoes come in pairs!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'pattern-complete',
      question: 'Skip count: 2, 4, 6, 8, ?',
      tillyPrompt: 'What comes after 8? Add 2!',
      options: [
        { id: 'nine', label: '9', isCorrect: false },
        { id: 'ten', label: '10', isCorrect: true },
        { id: 'eleven', label: '11', isCorrect: false }
      ],
      pattern: [2, 4, 6, 8],
      correctAnswer: 10
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Skip counting expert! Challenge Round: Count higher and fill in the missing number!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'pattern-complete',
          question: 'Continue: 10, 12, 14, ?',
          tillyPrompt: '14 plus 2 equals?',
          options: [
            { id: 'fifteen', label: '15', isCorrect: false },
            { id: 'sixteen', label: '16', isCorrect: true },
            { id: 'seventeen', label: '17', isCorrect: false }
          ],
          pattern: [10, 12, 14],
          correctAnswer: 16
        } as any,
        {
          id: 'challenge-2',
          type: 'pattern-complete',
          question: 'What is missing? 2, 4, ?, 8, 10',
          tillyPrompt: 'Between 4 and 8!',
          options: [
            { id: 'five', label: '5', isCorrect: false },
            { id: 'six', label: '6', isCorrect: true },
            { id: 'seven', label: '7', isCorrect: false }
          ],
          pattern: [2, 4, 8, 10],
          correctAnswer: 6
        } as any,
        {
          id: 'challenge-3',
          type: 'pattern-complete',
          question: 'Hard one: 14, 16, 18, ?',
          tillyPrompt: '18 plus 2!',
          options: [
            { id: 'nineteen', label: '19', isCorrect: false },
            { id: 'twenty', label: '20', isCorrect: true },
            { id: 'twentyone', label: '21', isCorrect: false }
          ],
          pattern: [14, 16, 18],
          correctAnswer: 20
        } as any
      ]
    },
    reward: {
      tillyLine: "Outstanding! You are a Skip Counting Master! You can count by 2s all the way to 20!",
      badgeName: 'Skip Counter',
      badgeIcon: '🦘',
      nextPreview: 'Next time, we will learn number neighbors!'
    }
  }
}
